import { rem } from 'polished';
import styled, { css } from 'styled-components';

export const StyledSharedHeader = css`
  position: sticky;
  top: 0;
  z-index: ${({ theme }) => theme.layers.header};
`;

export const StyledLanguageNavButton = styled.button`
  display: flex;
  align-items: center;
  padding: ${rem('8px')} 0;
  color: inherit;
  font-weight: 700;
  text-transform: inherit;
  border: none;
  background-color: transparent;
  appearance: none;
  cursor: pointer;

  > svg {
    width: ${rem('20px')};
    height: auto;
    margin-right: ${rem('10px')};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    &:hover {
      color: ${({ theme }) => theme.colors.cross.black};

      svg path {
        fill: ${({ theme }) => theme.colors.cross.black};
      }
    }
  }
`;
